import './search-featured-list.scss'

import { pluck, tap } from 'rxjs/operators'
import { Component, Watch } from 'vue-property-decorator'

import { SearchResponse, SearchResult, SearchFeatured, SearchParams, Wemi, SearchQuery } from '@skinsoft/types'
import { map } from '@skinsoft/data-store'
import { ItemDataStore, WemiDataStore } from '@skinsoft/entity'

import { ReactiveVue } from '@skinsoft/reactive-vue'
import { CreateReportSearchFeaturedCard } from '@skinsoft/entity-ui'
import { toSearchFeatured$ } from '@skinsoft/search-data-store/src/featured'
import { NB_ITEMS_SEARCH_RESULT_CHANGED_TOPIC } from '../../../../../apps/condition-report/src/busTopics'
import { TitleClickAction } from '../featured-card'

const SEARCH_FEATURED_ITEM_COUNT = 5;

@Component({
    components: {
        sCreateReportSearchFeaturedCard: CreateReportSearchFeaturedCard,
    },
    props: ['emptyMessage', 'title', 'targetRouteName', 'searchParams', 'displayedButtons', 'onlyInCache', 'titleClickAction'],
    template: require('./search-featured-list.html'),
})
export class SearchFeaturedList extends ReactiveVue {
    // TODO make it generic to keep one component ?
    public emptyMessage: string;
    public searchFeatureds: SearchFeatured[] = [];
    public title: string;
    public targetRouteName: string;
    public searchParams: SearchParams;

    public $itemDataStore: ItemDataStore;
    private displayedButtons: any[];
    private titleClickAction: TitleClickAction
    private onlyInCache: boolean;
    private onlyUploaded: boolean;

    private totalResults: number = 0;

    private subscribe() {
        const locale = this.getAppLocale()
        const sortObject =
            this.searchParams?.sortType?.length > 0
                ? { entityFields: this.searchParams.sortType, sortAsc: this.searchParams.sortAsc }
                : null

        if (this.onlyInCache || !window.navigator.onLine) {
            const searchQuery: SearchQuery = {
                queryText: this.searchParams.queryText,
                sortObject: sortObject,
                pageSize: this.searchParams.nbResults,
            }

            this.subscribeTo(
                this.$itemDataStore
                .searchAllOffline(
                    {
                        queryText: this.searchParams.queryText,
                        sortObject: sortObject,
                        pageSize: this.searchParams.nbResults,
                        language: this.getAppLocale(),
                    },
                    undefined,
                    undefined,
                    undefined,
                    this.onlyInCache,
                )
                .pipe(
                    tap((result: SearchResponse<SearchResult | Wemi>) => { this.totalResults = result.totalSize}),
                    pluck<SearchResponse<SearchResult | Wemi>, SearchResult[]>('allData'),
                    map((value: SearchResult) => {
                        return toSearchFeatured$(value, locale)
                    })
                ),
                (searchFeatureds: SearchFeatured[]) => {
                    this.searchFeatureds = searchFeatureds;
                    this.emitOnBus(NB_ITEMS_SEARCH_RESULT_CHANGED_TOPIC, { nbResults: searchFeatureds.length, totalResults: this.totalResults})
                },
                'searchFeatureds'
            )
        } else {
            
            this.subscribeTo(
                WemiDataStore.getInstance()
                    .searchAll(
                        {
                            queryText: this.searchParams.queryText,
                            sortObject: sortObject,
                            pageSize: this.searchParams.nbResults,
                            language: this.getAppLocale(),
                        },
                        undefined,
                        undefined,
                        undefined,
                        this.onlyInCache,
                    )
                    .pipe(
                        tap((result: SearchResponse<SearchResult | Wemi>) => { this.totalResults = result.totalSize }),
                        pluck<SearchResponse<SearchResult | Wemi>, SearchResult[]>('allData'),
                        map((value: SearchResult) => {
                            return toSearchFeatured$(value, locale)
                        })
                    ),
                (searchFeatureds: SearchFeatured[]) => {
                    if (this.onlyUploaded) {
                        this.searchFeatureds = searchFeatureds.filter(e => e.itemId.startsWith('_'));
                    } else {
                        this.searchFeatureds = searchFeatureds.filter(e => !e.itemId.startsWith('_'));
                    }
                    this.emitOnBus(NB_ITEMS_SEARCH_RESULT_CHANGED_TOPIC, { nbResults: searchFeatureds.length, totalResults: this.totalResults });
                },
                'searchFeatureds',
            );
        }
    }

    private unsubscribe() {
        this.unsubscribeFrom('searchFeatureds');
    }

    private mounted() {
        this.unsubscribe()
        this.subscribe()
    }

    @Watch('searchParams', { immediate: false, deep: true })
    private onSearchParamsChange() {
        // Testing all search params presence to avoid useless search query during params setting
        if (this.searchParams.nbResults && this.searchParams.sortType?.length) {
            this.unsubscribe();
            this.searchFeatureds = Array(SEARCH_FEATURED_ITEM_COUNT).fill(null);
            this.$emit('totalCount', null);
            this.subscribe();
        }
    }
}
